import { localTime, formatStartOf } from '@helpers';
import { DATE_FORMAT } from '@v2/pages/common/constants/base.constants';
import { DashboardOverviewDateRange } from '@reducers/v2/dashboard/types';

export const computeDashboardDateRange = (range: DashboardOverviewDateRange): { from: string; to: string } | null => {
  switch (range) {
    case DashboardOverviewDateRange.SEVEN_DAYS: {
      const from = localTime().subtract(7, 'days');
      const to = localTime();
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.YESTERDAY: {
      const from = localTime().subtract(1, 'day').startOf('day');
      const to = from.clone().add(1, 'day');
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.THIS_WEEK: {
      const from = localTime().startOf(formatStartOf('week'));
      const to = from.clone().add(1, 'week');
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.LAST_WEEK: {
      const from = localTime().subtract(1, 'week').startOf(formatStartOf('week'));
      const to = from.clone().add(1, 'week');
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.CURRENT_MONTH: {
      const from = localTime().startOf(formatStartOf('month'));
      const to = from.clone().add(1, 'month');
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.PREVIOUS_MONTH: {
      const from = localTime().subtract(1, 'month').startOf(formatStartOf('month'));
      const to = from.clone().add(1, 'month');
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.CURRENT_YEAR: {
      const from = localTime().startOf(formatStartOf('year'));
      const to = from.clone().add(1, 'year');
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.PREVIOUS_YEAR: {
      const from = localTime().subtract(1, 'year').startOf(formatStartOf('year'));
      const to = from.clone().add(1, 'year');
      return { from: from.format(DATE_FORMAT), to: to.format(DATE_FORMAT) };
    }
    case DashboardOverviewDateRange.CUSTOM:
      return null;
  }
};
